

export const ModuleConstant = {
  Dashboard: "Dashboard",
  Repository: "Repo",
  Project_Listing: "PL",
  Project_Initiation: "PI",
  IPD: "IPD",
  Initiation_Approval: "PIA",
  Cogs_Estimation: "Cogs",
  Commercials: "Commercials",
  In_House_Selection: "InHouse",
  Formulation_Budget_Form: "FormulationDev",
  API_Development_Form: "APIDev",
  API_Commercials: "APIComm",
  In_Licensed_Project: "InLicensed",
  Final_Schedule: "FinalSchedule",
  Revenue_GC_RollUp: "Revenue",
  Final_PL_Evaluataion: "FinalPL",
  Reports: "Reports",
  Admin: "Admin",
  UserManagement: "UserManagement",
  MasterManagement: "MasterManagement",
  DateFormat: "DateFormat",
  GroupCurrency: "GroupCurrency",
  FinalApproval: "FinalApproval",
  Level1Approval: "Level1Approval",
  Level2Approval: "Level2Approval",
  GroupUom: "GroupUom",
  //Formulation Development sub-modules
  Formulation_Development: "FormDev",
  API: "API",
  Excipients_PM: "ExcPM",
  Analytical: "Analytical",
  BE_RLD_Cost: "BERLDCost",
  Tooling_Plant_Cost: "ToolPlantCost",
  Manpower_Cost: "ManpowerCost",
  Filing_Cost: "FilingCost",
  //API Development sub-modules
  API_Development: "APIDevelopment",
  API_Requirement: "APIReq",
  Other_Materials: "OtherMat",
  Analytical_API: "AnalyticalAPI",
  Manpower_API: "ManpowerAPI",
  Tooling: "Tooling",
  Plant_Cost: "PlantCost",
  API_Filing_Cost: "APIFilingCost",
  Documents: "Documents",
};
